// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"490931f0","611":"a873628b"}[chunkId] + ".js";
};